import React from "react";
import { LayoutDashboard, Layers, Users, ShieldCheck, FileText, ChevronRight } from "lucide-react";
import { usePermission } from "@/hooks/usePermission";

export type NavTab = "dashboard" | "applications" | "users" | "roles" | "audit";

interface SidebarProps {
  activeTab: NavTab;
  onSelectTab: (tab: NavTab) => void;
  isOpen?: boolean;
  onClose?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  activeTab,
  onSelectTab,
  isOpen = false,
  onClose,
}) => {
  const { hasPermission } = usePermission();

  const navItems = [
    {
      id: "dashboard" as NavTab,
      label: "Visão Geral",
      icon: LayoutDashboard,
      allowed: true,
    },
    {
      id: "applications" as NavTab,
      label: "Aplicações & Tenants",
      icon: Layers,
      allowed: hasPermission("applications:list"),
    },
    {
      id: "users" as NavTab,
      label: "Gestão de Usuários",
      icon: Users,
      allowed: hasPermission("users:list"),
    },
    {
      id: "roles" as NavTab,
      label: "Roles & Permissões",
      icon: ShieldCheck,
      allowed: hasPermission("roles:list"),
    },
    {
      id: "audit" as NavTab,
      label: "Trilha de Auditoria",
      icon: FileText,
      allowed: hasPermission("audit:list"),
    },
  ];

  return (
    <>
      {isOpen && (
        <button
          type="button"
          className="sidebar-backdrop mobile-only"
          onClick={onClose}
          aria-label="Fechar menu lateral"
          tabIndex={-1}
        />
      )}
      <aside className={`sidebar ${isOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-section">
          <p className="sidebar-heading">Menu de Administração</p>
          <nav className="sidebar-nav">
            {navItems.map(
              (item) =>
                item.allowed && (
                  <button
                    key={item.id}
                    type="button"
                    className={`sidebar-link ${activeTab === item.id ? "sidebar-link-active" : ""}`}
                    onClick={() => {
                      onSelectTab(item.id);
                      if (onClose) onClose();
                    }}
                  >
                    <div className="flex items-center gap-3">
                      <item.icon size={18} className="sidebar-icon" />
                      <span>{item.label}</span>
                    </div>
                    {activeTab === item.id && <ChevronRight size={16} className="sidebar-arrow" />}
                  </button>
                ),
            )}
          </nav>
        </div>

        <div className="sidebar-footer">
          <div className="system-status">
            <span className="status-dot"></span>
            <span className="text-xs text-muted">Auth API: Conectado</span>
          </div>
          <span className="text-xs text-muted">v1.0.0 (Static Build)</span>
        </div>
      </aside>
    </>
  );
};
